import React from "react";
import "./IleTheatreJeunePublic.scss";
import IslandVideo from "../../components/ui/IslandVideo";

export default function IleTheatreJeunePublic({ OnClick }) {
	return (
		<>
			<div onClick={OnClick} className='small_island' id='ilediscussionjeunepublic'>
				<div className='video_container'>
					<IslandVideo
						webmSrc='/videos/iles/pourquoi_theatre_jeune_public-vp9-chrome.webm'
						mp4Src='/videos/iles/pourquoi_theatre_jeune_public-hevc-safari.mp4'
					/>
				</div>
				<div className='text'>
					<h2 className='island_title'>
						<span className='breakDown'>Theatre </span>Jeune Public
					</h2>
					<p>Pourquoi vous faites ça ?</p>
				</div>
			</div>
		</>
	);
}
